import n from"@babel/runtime-corejs3/core-js-stable/instance/find";function t(t,r){if(r.length&&void 0!==n(r).call(r,(function(n){return n===t||"".concat(n)==="".concat(t)})))return!0;return!1}export{t as contains};
//# sourceMappingURL=contains.js.map
